import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="final-wishes-question"
export default class extends Controller {
  static targets = ["form", "backToQuestions", "continue", "finalWishesIndex", "nextCategory"];
  static values = { savedModalId: String, completeModalId: String };

  async save(event) {
    event.preventDefault();

    const data = await this.submit();
    if (!data) return;

    if (data?.back_to_questions_path && this.hasBackToQuestionsTarget) {
      this.backToQuestionsTarget.setAttribute("href", data.back_to_questions_path);
    }
    // Save modal continues to the next question (sequential), per current UX.
    if (data?.next_question_path && this.hasContinueTarget) {
      this.continueTarget.setAttribute("href", data.next_question_path);
    }

    await this.openModal(this.savedModalIdValue);
  }

  async continue(event) {
    event.preventDefault();

    const data = await this.submit();
    if (!data) return;

    if (data?.all_answered) {
      if (data?.final_wishes_index_path && this.hasFinalWishesIndexTarget) {
        this.finalWishesIndexTarget.setAttribute("href", data.final_wishes_index_path);
      }
      if (data?.next_category_path && this.hasNextCategoryTarget) {
        this.nextCategoryTarget.setAttribute("href", data.next_category_path);
      }
      await this.openModal(this.completeModalIdValue);
      return;
    }

    if (data?.next_question_path) {
      window.location.assign(data.next_question_path);
    }
  }

  async submit() {
    const form = this.formTarget;
    // Sync question-card so "other" textarea gets the param name when "Other" is selected.
    const cardEl = form.querySelector("[data-controller*='question-card']");
    if (cardEl) {
      const controller = this.application.getControllerForElementAndIdentifier(cardEl, "question-card");
      if (controller && typeof controller.updateOtherInputVisibility === "function") {
        controller.updateOtherInputVisibility();
      }
    }
    let body = new FormData(form);
    // Fallback: if "other" textarea is visible and has value, ensure that value is sent (param name from data attr).
    const otherContainer = form.querySelector("[data-question-card-target='otherInput']");
    const paramName = cardEl?.dataset?.questionCardParamNameValue;
    if (paramName && otherContainer && !otherContainer.classList.contains("hidden")) {
      const textarea = otherContainer.querySelector("textarea");
      if (textarea?.value?.trim()) {
        body.set(paramName, textarea.value.trim());
      }
    }
    const token = document.querySelector("meta[name='csrf-token']")?.content;

    const response = await fetch(form.action, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        ...(token ? { "X-CSRF-Token": token } : {}),
      },
      body,
      credentials: "same-origin",
    });

    if (!response.ok) return null;

    try {
      return await response.json();
    } catch (_) {
      return null;
    }
  }

  async openModal(modalId) {
    window.HSStaticMethods?.autoInit?.();
    if (!modalId) return;

    // Reuse the same waiting strategy as the existing preline/modal controller.
    await this.waitForHSOverlay();
    if (window.HSOverlay?.getInstance?.(`#${modalId}`)) {
      window.HSOverlay.open(`#${modalId}`);
    }
  }

  waitForHSOverlay() {
    const maxAttempts = 20;

    return new Promise((resolve, reject) => {
      let attempts = 0;
      const interval = setInterval(() => {
        if (window.HSOverlay && window.HSOverlay.getInstance) {
          clearInterval(interval);
          resolve();
        } else if (attempts >= maxAttempts) {
          clearInterval(interval);
          reject(new Error("HSOverlay failed to load."));
        }
        attempts++;
      }, 200);
    });
  }
}

